export const POST_REQUEST = "POST_REQUEST";
export const POST_FAILURE = "POST_FAILURE";
export const DELETE_SUCCESS = "DELETE_SUCCESS";

export const POST_ADDRESS_SUCCESS = "POST_ADDRESS_SUCCESS";
export const GET_ADDRESS_SUCCESS = "GET_ADDRESS_SUCCESS";

export const PATCH_SUCCESS = "PATCH_SUCCESS";
